import React, { useState, useMemo, useEffect } from "react";
import { Modal } from "react-bootstrap";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import StepItemCard from "./StepItemCard";
import PreviewFile from "./PreviewFile";
import Spinner from "../component/Spinner";
import SearchBoxModal from "../component/SearchBoxModal";
import { MyCurrentTime, vnDateTime } from "../configs";
import InputMask from "react-input-mask";
import { confirmAlert } from "react-confirm-alert";
import MessageBox from "./MessageBox";
import { checkRole } from "../model";
import Moment from "react-moment";
import DateTimePicker from "react-datetime-picker";
import moment from "moment";

export default function KanbanBoard({ listMission, listSettings, onRefresh, user, detail, canEdit }) {
    const [loading, setLoading] = useState(false);
    const [modalTask, setModalTask] = useState(false);
    const [listUsers, setListUsers] = useState([]);
    const [hoverStar, setHoverStar] = useState(0);
    const [workForMyselt, setWorkForMyselt] = useState(false);
    const workId = detail ? detail.id : 0;
    const roleAssign = checkRole(user, 'works_order', 'assign');
    const roleDelete = checkRole(user, 'works_order', 'delete');
    const [dateSelect, setDateSelect] = useState(null);
    const [selectedFollower, setSelectedFollower] = useState(null);
    const numberStar = 5;

    // Khởi tạo Task mới trực thuộc WorksOrder
    const defaultTask = {
        work_id: workId,
        status: '',
        title: '',
        description: '',
        tags: '',
        list_file: [],
        followers: [] // Đón đầu mảng followers cho task mới tạo rỗng
    };
    const [dataTask, setDataTask] = useState(defaultTask);

    const isEditable = (
        (dataTask && (dataTask.author_id === user.data.id || dataTask.user_id === user.data.id || !dataTask.id))
        && Number(dataTask.status || 1) < 3
    );

    const kanbanColumns = useMemo(() => {
        if (!listSettings) return [];

        // Lấy chính xác ID người dùng hiện tại từ cấu trúc user.data.id của bạn
        const currentUserId = Number(user?.data?.id || user?.id || user?.user_id || 0);

        // Sắp xếp các cột kanban theo vị trí ban đầu
        const sortedSettings = [...listSettings].sort((a, b) => a.position - b.position);

        return sortedSettings.map(setting => {
            // Lọc các item thuộc cột này
            const columnItems = (listMission || []).filter(
                item => Number(item.status) === Number(setting.id)
            );
            // SẮP XẾP ƯU TIÊN THEO ĐA ĐIỀU KIỆN (Có tính trọng số Follower từ API mới)
            const prioritizedItems = columnItems.sort((a, b) => {
                if (!currentUserId) return b.id - a.id;
                // Kiểm tra xem user hiện tại có nằm trong danh sách followers của công việc không
                const aIsFollower = a.followers?.some(f => Number(f.user_id) === currentUserId) ? 1 : 0;
                const bIsFollower = b.followers?.some(f => Number(f.user_id) === currentUserId) ? 1 : 0;
                // Tính toán trọng số ưu tiên: Được giao (4 điểm) > Tự tạo (2 điểm) > Theo dõi (1 điểm)
                const aWeight = (Number(a.user_id) === currentUserId ? 4 : 0) +
                    (Number(a.author_id) === currentUserId ? 2 : 0) +
                    (aIsFollower ? 1 : 0);

                const bWeight = (Number(b.user_id) === currentUserId ? 4 : 0) +
                    (Number(b.author_id) === currentUserId ? 2 : 0) +
                    (bIsFollower ? 1 : 0);

                if (aWeight !== bWeight) {
                    return bWeight - aWeight;
                }

                return b.id - a.id;
            });

            return {
                ...setting,
                items: prioritizedItems.map(item => {
                    let decodedFiles = [];
                    if (item.list_file) {
                        try {
                            decodedFiles = typeof item.list_file === 'string'
                                ? JSON.parse(item.list_file)
                                : item.list_file;
                        } catch (e) {
                            console.error("Lỗi parse list_file ở item: " + item.id, e);
                            decodedFiles = [];
                        }
                    }

                    return {
                        ...item,
                        list_file_decoded: decodedFiles
                    };
                })
            };
        });
        // Sửa lại dependency tracking theo object user.data.id để cập nhật chính xác nhất
    }, [listMission, listSettings, user?.data?.id]);

    const handleOpenAdd = (columnId) => {
        setDataTask({ ...defaultTask, status: columnId });
        setModalTask(true);
    };

    const handleSaveTask = () => {
        if (!dataTask.title) return alert("Vui lòng nhập tiêu đề công việc");
        if (!dataTask.department_id) return alert("Vui lòng chọn phòng ban liên quan");

        setLoading(true);
        const payload = {
            ...dataTask,
            work_id: workId,
            author_id: user.data.id,
            list_file: JSON.stringify(dataTask.list_file)
        };
        if (dataTask.id) {
            Axios.put(URL_LIST_ALL + 'works_order_step_items/' + dataTask.id, payload, user.config)
                .then(res => {
                    setLoading(false);
                    if (res.data.status === "success") {
                        setModalTask(false);
                        onRefresh();
                    }
                })
                .catch(err => { setLoading(false); console.error(err); });
        } else {
            Axios.post(URL_LIST_ALL + 'works_order_step_items', payload, user.config).then(res => {
                setLoading(false);
                if (res.data.status === "success") {
                    setModalTask(false);
                    onRefresh();
                }
            }).catch(err => { setLoading(false); console.error(err); });
        }
    };

    useEffect(() => {
        if (dataTask.department_id) {
            let config = {
                headers: {
                    'Authorization': 'Bearer ' + user.access_token,
                    'asselect': JSON.stringify(["id as value", "fullname as name"])
                }
            };
            Axios.get(URL_LIST_ALL + "users?limit=10000&part_id=" + dataTask.department_id, config)
                .then((res) => {
                    if (res.data.status === "success") setListUsers(res.data.data);
                })
                .catch((err) => console.log(err));
        }
    }, [dataTask.department_id, user.access_token]);

    useEffect(() => {
        if (workForMyselt) {
            setDataTask(prev => ({ ...prev, department_id: user.data.part_id, user_id: user.data.id }));
        }
    }, [workForMyselt, user.data.part_id, user.data.id]);

    // Đồng bộ ngược dữ liệu thời gian thực từ listMission vào Modal (Bao gồm cả mảng followers mới)
    useEffect(() => {
        if (modalTask && dataTask && dataTask.id) {
            const updatedTask = listMission.find(item => item.id === dataTask.id);
            if (updatedTask) {
                setDataTask(prev => ({
                    ...prev,
                    ...updatedTask,
                    // Đồng bộ và bảo toàn mảng người theo dõi mới từ API
                    followers: updatedTask.followers || [],
                    list_file: typeof updatedTask.list_file === 'string'
                        ? JSON.parse(updatedTask.list_file || '[]')
                        : updatedTask.list_file
                }));
            }
        }
    }, [listMission, modalTask]);

    const onEditStep = (dataStep) => {
        setDataTask(defaultTask);
        if (dataStep) {
            let files = [];
            try {
                files = typeof dataStep.list_file === 'string'
                    ? JSON.parse(dataStep.list_file || '[]')
                    : (dataStep.list_file || []);
            } catch (e) {
                files = [];
            }

            setDataTask({
                ...dataStep,
                time_expected_completion: dataStep.time_expected_completion,
                list_file: files,
                followers: dataStep.followers || [] // Gán followers khi mở modal chi tiết
            });
            setModalTask(true);
        }
    };

    const ActionMember = (dataStep, status) => {
        if (dataStep && dataStep.id && status) {
            const datasave = {
                user_recipient: user.data.id,
                user_id: user.data.id,
                status: status
            };
            if (status == 2) {
                if (dataStep.status == 5 || dataStep.status == 4) {
                    sendActionToChatBox("Đã tiếp tục công việc");
                } else {
                    sendActionToChatBox("Đã nhận việc");
                    datasave.time_received = MyCurrentTime();
                }
            }
            if (status == 3) {
                sendActionToChatBox("Đã hoàn thành công việc");
                datasave.time_finish = MyCurrentTime();
            }
            if (status == 4) {
                sendActionToChatBox("Đã hủy bỏ công việc");
            }
            if (status == 5) {
                sendActionToChatBox("Đã tạm dừng công việc");
            }
            Axios.put(URL_LIST_ALL + 'works_order_step_items/' + dataStep.id, datasave, user.config).then(res => {
                setLoading(false);
                if (res.data.status === "success") {
                    setModalTask(false);
                    onRefresh();
                }
            }).catch(err => { setLoading(false); console.error(err); });
        }
    };

    const handleRating = (val) => {
        Axios.put(URL_LIST_ALL + 'works_order_step_items/' + dataTask.id, {
            ratings: val,
            user_rating: user.data.id,
            time_rating: MyCurrentTime()
        }, user.config).then(res => {
            if (res.data.status === "success") {
                setDataTask(prev => ({ ...prev, ratings: val }));
                sendActionToChatBox(`Đánh giá công việc ${val}` + " <span class=\"fas fa-star text-warning\"></span>");
                onRefresh();
            }
        });
    };

    const DeleteJob = (val) => {
        confirmAlert({
            title: "Cảnh báo",
            message: "Bạn có chắc chắn xóa?",
            buttons: [{
                label: "OK",
                onClick: () => {
                    Axios.delete(URL_LIST_ALL + 'works_order_step_items/' + val.id, user.config).then(res => {
                        if (res.data.status === "success") {
                            onRefresh();
                            setModalTask(false);
                        }
                    });
                }
            }]
        });
    };

    const loopStar = () => {
        const elements = [];
        const currentStar = dataTask.ratings ? parseInt(dataTask.ratings) : 0;
        const activeStar = hoverStar > 0 ? hoverStar : currentStar;
        const canRatting = (detail.author_id == user.data.id) || (user.data.id == dataTask.author_id) || (roleAssign && user.data.part_id == dataTask.department_id);
        for (let i = 1; i <= numberStar; i++) {
            elements.push((canRatting) ?
                <button
                    type="button"
                    key={dataTask.id + i}
                    style={{ border: 'none', background: 'none', padding: 0 }}
                    onMouseEnter={() => setHoverStar(i)}
                    onMouseLeave={() => setHoverStar(0)}
                    onClick={() => handleRating(i)}
                >
                    <span style={{ fontSize: 26 }} className={i <= activeStar ? "fas fa-star text-warning" : "far fa-star text-warning"}></span>
                </button>
                :
                <span style={{ fontSize: 26 }} key={dataTask.id + i} className={i <= activeStar ? "fas fa-star text-warning" : "far fa-star text-warning"}></span>
            );
        }
        return <div className="d-flex">{elements}</div>;
    };

    const sendActionToChatBox = (chatInput) => {
        if (!chatInput.trim()) return;
        const payload = {
            work_id: workId,
            target_id: dataTask.id,
            message_content: chatInput,
            user_id: user.data.id,
            type: 'chat',
        };
        setLoading(true);
        Axios.post(URL_LIST_ALL + 'works_order_messages', payload, user.config)
            .then(res => { setLoading(false); })
            .catch(err => console.error(err));
    };

    const handleDateChange = (value) => {
        const formattedDate = value ? moment(value).format('YYYY-MM-DD') : null;
        setDataTask(prev => ({
            ...prev,
            time_expected_completion: formattedDate
        }));
    };

    const handleAddFollower = () => {
        // 1. Kiểm tra xem đã có ID công việc chưa (chỉ thêm được khi việc đã tạo)
        if (!dataTask.id) return alert("Vui lòng lưu công việc trước khi thêm người theo dõi");

        const followerId = selectedFollower?.id;
        const followerName = selectedFollower?.fullname || "Nhân viên";

        if (!followerId) return alert("Vui lòng chọn nhân sự");

        // 2. Kiểm tra trùng lặp trong danh sách hiện tại
        const isExisted = dataTask.followers?.some(f => Number(f.user_id) === Number(followerId));
        if (isExisted) return alert("Nhân sự này đã nằm trong danh sách theo dõi");

        setLoading(true);
        const payload = {
            step_item_id: dataTask.id,
            user_id: followerId
        };

        // 3. Gọi API lưu vào bảng works_order_user_join
        Axios.post(URL_LIST_ALL + 'works_order_user_join', payload, user.config)
            .then(res => {
                setLoading(false);
                if (res.data.status === "success") {
                    // Tạo object follower mới từ chính dữ liệu trong State gộp
                    const newFollowerObj = {
                        step_item_id: dataTask.id,
                        user_id: Number(followerId),
                        fullname: followerName,
                        email_alias: ""
                    };

                    // Đẩy thẳng vào danh sách đang hiển thị để giao diện re-render realtime
                    setDataTask(prev => ({
                        ...prev,
                        followers: [...(prev.followers || []), newFollowerObj]
                    }));

                    // Reset state chọn sau khi thêm thành công (tùy chọn, giúp trống ô chọn tiếp)
                    setSelectedFollower(null);

                    // Cập nhật lại Kanban ngoài màn hình chính
                    onRefresh();
                } else {
                    alert(res.data.message || "Có lỗi xảy ra khi thêm người theo dõi");
                }
            })
            .catch(err => {
                setLoading(false);
                console.error("Lỗi thêm follower:", err);
                alert("Không thể kết nối đến máy chủ");
            });
    };

    return (
        <div className="row mt-4 kanban-container flex-nowrap pb-4" style={{ overflowX: 'auto' }}>
            {kanbanColumns.map((column) => (
                <div className="col-12 col-md-4 col-lg-3 kanban-column" key={column.id} style={{ minWidth: '300px' }}>
                    <div className="card shadow-sm border-0 h-100" style={{ backgroundColor: '#ebedf0' }}>
                        <div className="card-header d-flex justify-content-between align-items-center"
                            style={{ borderTop: `4px solid ${column.color}`, backgroundColor: '#f8f9fa' }}>
                            <span className="font-weight-bold text-uppercase" style={{ color: column.color }}>{column.title}</span>
                            <span className="badge badge-pill badge-secondary">{column.items.length}</span>
                        </div>

                        <div className="card-body p-2 scrollbar-style" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                            {column.can_create === 1 && (
                                <button type="button" className="btn btn-block btn-outline-success btn-success btn-sm text-white mb-2 border"
                                    onClick={() => handleOpenAdd(column.id)}>
                                    <i className="fas fa-plus mr-1"></i> Thêm công việc mới
                                </button>
                            )}

                            {column.items.map((task) => (
                                <StepItemCard
                                    key={task.id}
                                    item={task}
                                    user={user}
                                    columnColor={column.color}
                                    onEdit={data => onEditStep(data)}
                                    numberStar={numberStar}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            ))}
            <Modal show={modalTask} onHide={() => setModalTask(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title className="w-100 d-flex align-items-center h6">
                        <h5>
                            {!canEdit || dataTask.status != 1}
                            {dataTask && dataTask.id ?
                                <p className="pt-1 pl-2 pr-2 pb-1" style={{ color: dataTask.status_color, borderColor: dataTask.status_color, borderWidth: 1, borderStyle: "solid" }}>
                                    Công việc {dataTask.text_status}
                                </p>
                                : "Tạo công việc mới"}
                        </h5>
                        {dataTask && dataTask.id ? <p className="ml-2 mb-0 text-danger">Người tạo: {dataTask.author_email}</p> : ""}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12 col-sm-6">
                            <div className="form-group mb-3">
                                <label className="small font-weight-bold">Nội dung công việc</label>
                                {isEditable || ((dataTask.status == 1 || dataTask.status == 2) && dataTask.author_id == user.data.id) ?
                                    <textarea className="form-control" rows="3" placeholder="Nhập nội dung công việc"
                                        value={dataTask.title || ''}
                                        onChange={e => setDataTask({ ...dataTask, title: e.target.value })}></textarea>
                                    :
                                    <p className="form-control h-auto">{dataTask.title}</p>
                                }
                            </div>
                            <div className="form-group mb-3">
                                <label className="small font-weight-bold">Nhãn (Tags) - Phân loại</label>
                                {isEditable || ((dataTask.status == 1 || dataTask.status == 2) && dataTask.author_id == user.data.id) ?
                                    <input type="text" className="form-control height32" placeholder="VD: Giai đoạn 1, Ưu tiên..."
                                        value={dataTask.tags || ''}
                                        onChange={e => setDataTask({ ...dataTask, tags: e.target.value })} />
                                    :
                                    <p className="form-control">{dataTask.tags}</p>
                                }
                            </div>
                            {(isEditable && (!dataTask.id || dataTask.id == 0)) &&
                                <div className="form-check pl-0 mb-3">
                                    <button className={"btn btn-sm " + (workForMyselt ? "btn-info" : "btn-outline-info")} type="button" onClick={() => setWorkForMyselt(!workForMyselt)}>
                                        <span className={"far mr-2 " + (workForMyselt ? "fas fa-check-square" : "far fa-square")}></span>Tạo cho bản thân
                                    </button>
                                </div>
                            }
                            <div className="form-group">
                                <small className="font-weight-bold">Phòng ban thực hiện</small>
                                {isEditable && dataTask.status == 1 ?
                                    <SearchBoxModal
                                        apiname={"parts"}
                                        placeholder="Chọn phòng ban"
                                        colvalue={'id'}
                                        colname={'title'}
                                        defaultValue={dataTask.department_id}
                                        onChange={(val) => setDataTask(prev => ({ ...prev, department_id: val }))}
                                    />
                                    :
                                    <p className="form-control h-auto">{dataTask.department_name}</p>
                                }

                                <small className="font-weight-bold mt-2 d-block">Nhân sự thực hiện</small>
                                {(isEditable || roleAssign) && (dataTask.status == 1 || dataTask.status == 2) ?
                                    <select
                                        className="w-100 form-select mt-1"
                                        value={dataTask.user_id ? dataTask.user_id : 0}
                                        onChange={(e) => setDataTask({ ...dataTask, user_id: e.target.value })}
                                    >
                                        <option value="">Chọn nhân sự tham gia</option>
                                        {listUsers.map((u) => <option key={u.value} value={u.value}>{u.label}</option>)}
                                    </select>
                                    :
                                    <p className="form-control h-auto">{dataTask.fullname}</p>
                                }
                            </div>
                            <div className="form-group">
                                <label className="small font-weight-bold">File đính kèm</label>
                                <PreviewFile detail={dataTask}
                                    itemClass="col-12 col-sm-4 mb-3" isEdit={isEditable || ((dataTask.status == 1 || dataTask.status == 2) && dataTask.author_id == user.data.id)}
                                    onSelect={files => setDataTask({ ...dataTask, list_file: [...dataTask.list_file, ...files] })}
                                    onRemove={idx => setDataTask({ ...dataTask, list_file: dataTask.list_file.filter((_, i) => i !== idx) })} />
                            </div>
                            <div className="form-group">
                                <label className="small font-weight-bold">Thời gian dự kiến hoàn thành</label>
                                {((isEditable || roleAssign) && (!dataTask.time_expected_completion)) ?
                                    <DateTimePicker
                                        onChange={handleDateChange}
                                        value={dataTask.time_expected_completion ? new Date(dataTask.time_expected_completion) : null}
                                        format="dd/MM/yyyy"
                                        className="form-control height32 air-datepicker"
                                        minDate={dataTask.time_expected_completion ? new Date(dataTask.time_expected_completion) : new Date()}
                                        clearIcon={null}
                                    />
                                    :
                                    <p className="form-control h-auto">
                                        {dataTask.time_expected_completion ? (
                                            <Moment format="DD/MM/YYYY">{new Date(dataTask.time_expected_completion)}</Moment>
                                        ) : "Chưa đặt hạn"}
                                    </p>
                                }
                            </div>
                            <div className="form-group">
                                <label>Người quan sát</label>
                                <div className="w-100 d-flex justify-content-between">
                                    <SearchBoxModal
                                        apiname={"users"}
                                        placeholder="Chọn nhân sự"
                                        colvalue={'id'}
                                        colname={'fullname'}
                                        onChange={(val) => setSelectedFollower(prev => ({ ...prev, id: val }))}
                                        onLabel={(label) => setSelectedFollower(prev => ({ ...prev, fullname: label }))}
                                    />
                                    <button
                                        className="btn btn-sm btn-info ml-2 px-3"
                                        type="button"
                                        disabled={loading || !selectedFollower?.id}
                                        onClick={handleAddFollower} // Đã chuyển thành function gọn gàng ở đây
                                    >Thêm</button>
                                </div>
                                <div className="col-12 p-0 mt-2">
                                    <div className="d-flex flex-wrap">
                                        {dataTask.followers && dataTask.followers.map((fl, index) => (
                                            <div
                                                key={fl.user_id || index}
                                                className="badge badge-light p-2 mr-2 mb-2 border d-flex align-items-center"
                                                style={{ fontSize: '13px', backgroundColor: '#f1f3f5', borderRadius: '4px' }}
                                            >
                                                <i className="fas fa-user text-secondary mr-2"></i>
                                                <strong className="text-dark">{fl.fullname}</strong>

                                                <span
                                                    className="ml-2 text-danger font-weight-bold"
                                                    style={{ cursor: 'pointer', padding: '0 4px', fontSize: '14px' }}
                                                    onClick={() => {
                                                        confirmAlert({
                                                            title: "Xác nhận",
                                                            message: `Bỏ theo dõi đối với ${fl.fullname}?`,
                                                            buttons: [{
                                                                label: "OK",
                                                                onClick: () => {
                                                                    setLoading(true);
                                                                    Axios.delete(`${URL_LIST_ALL}works_order_user_join?step_item_id=${dataTask.id}&user_id=${fl.user_id}`, user.config)
                                                                        .then(res => {
                                                                            setLoading(false);
                                                                            if (res.data.status === "success") {
                                                                                setDataTask(prev => ({
                                                                                    ...prev,
                                                                                    followers: prev.followers.filter(f => f.user_id !== fl.user_id)
                                                                                }));
                                                                                onRefresh();
                                                                            }
                                                                        }).catch(err => { setLoading(false); console.error(err); });
                                                                }
                                                            }]
                                                        });
                                                    }}
                                                >
                                                    &times;
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="footer-modal">
                                {((isEditable || roleAssign) && dataTask.status <= 2) ? <button className="btn btn-sm btn-success w-100" onClick={handleSaveTask} disabled={loading}>
                                    {loading ? <Spinner /> : "Lưu lại"}
                                </button> : ""}
                                <div className="w-100 d-flex mt-2 justify-content-between">
                                    {((dataTask.user_id == user.data.id || (dataTask.user_id == null && dataTask.department_id == user.data.part_id))) &&
                                        <>
                                            {(dataTask.status == 1 && dataTask.id) &&
                                                <button className="btn btn-sm btn-success text-white" type="button" onClick={() => ActionMember(dataTask, 2)}> {loading ? <Spinner /> : "Nhận việc"}</button>
                                            }
                                            {dataTask.status == 2 &&
                                                <>
                                                    <button className="btn btn-sm btn-success text-white" type="button" onClick={() => ActionMember(dataTask, 3)}>{loading ? <Spinner /> : "Hoàn thành"}</button>
                                                    <button className="btn btn-sm btn-warning text-white" type="button" onClick={() => ActionMember(dataTask, 5)}>{loading ? <Spinner /> : "Tạm dừng"}</button>
                                                    <button className="btn btn-sm btn-danger text-white" type="button" onClick={() => ActionMember(dataTask, 4)}>{loading ? <Spinner /> : "Hủy bỏ"}</button>
                                                </>
                                            }
                                            {dataTask.status == 4 &&
                                                <button className="btn btn-sm btn-success text-white" type="button" onClick={() => ActionMember(dataTask, 2)}>{loading ? <Spinner /> : <><span className="fas fa-arrow-left"></span> Khôi phục công việc</>}</button>
                                            }
                                            {dataTask.status == 5 &&
                                                <>
                                                    <button className="btn btn-sm btn-success text-white" type="button" onClick={() => ActionMember(dataTask, 2)}>{loading ? <Spinner /> : "Tiếp tục công việc"}</button>
                                                    <button className="btn btn-sm btn-danger text-white" type="button" onClick={() => ActionMember(dataTask, 4)}>{loading ? <Spinner /> : "Hủy bỏ"}</button>
                                                </>
                                            }
                                        </>
                                    }
                                    {(dataTask && dataTask.id && (roleDelete || dataTask.author_id == user.data.id)) &&
                                        <button className="btn btn-sm btn-danger text-white" type="button" onClick={() => DeleteJob(dataTask)}>{loading ? <Spinner /> : "Xóa việc"}</button>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6">
                            {(dataTask && dataTask.status == 3) ?
                                <div className="w-100 mb-2">
                                    <label className="small font-weight-bold">Đánh giá công việc</label>
                                    {loopStar()}
                                </div>
                                : ""}
                            <div className="w-100">
                                <MessageBox
                                    workId={workId}
                                    targetId={dataTask.id}
                                    user={user}
                                />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}